import React from "react";
import { useAuth } from "@/context/AuthContext";
import { isGlobal } from "@/lib/access";
import { useTenants } from "@/hooks/useTenants";

// Adds a "Tenant" column only when the user has GLOBAL visibility (Super Admin).
export function useTenantColumn(resource) {
  const { user } = useAuth();
  const show = isGlobal(user, resource, "view");
  const { data } = useTenants();
  const name = (id) => (data?.items || []).find((t) => t.internalId === id)?.name || id || "—";
  const column = show
    ? { key: "tenant", label: "Tenant", render: (r) => <span className="text-muted-foreground">{name(r.tenant_id)}</span> }
    : null;
  const inject = (cols, atIndex = 2) => {
    if (!column) return cols;
    const next = [...cols];
    next.splice(atIndex, 0, column);
    return next;
  };
  return { show, name, column, inject };
}
